import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-playSmall",
  "use": "icon-playSmall-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-playSmall\">\n<path d=\"M1.78931 6.00007V2.78354C1.78931 1.85978 2.78931 1.28243 3.58931 1.74431L6.37489 3.35258L9.16048 4.96084C9.96048 5.42272 9.96048 6.57742 9.16048 7.0393L6.37489 8.64757L3.58931 10.2558C2.78931 10.7177 1.78931 10.1404 1.78931 9.2166V6.00007Z\" stroke=\"#999999\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol